// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_3uc2r","loader":"_3HsG5"};